import React from 'react';
import { Row, Col } from 'reactstrap';

const Pagination = ({
    currentPage,
    totalPages,
    totalItems,
    pageSize,
    onPageChange,
    showInfo = true,
    className = "pagination justify-content-center mb-0"
}) => {
    const getVisiblePages = () => {
        const delta = 1;
        const range = [];
        const rangeWithDots = [];

        const start = Math.max(1, currentPage - delta);
        const end = Math.min(totalPages, currentPage + delta);

        for (let i = start; i <= end; i++) {
            range.push(i);
        }

        if (start > 1) {
            rangeWithDots.push(1);
            if (start > 2) {
                rangeWithDots.push('...');
            }
        }

        rangeWithDots.push(...range);

        if (end < totalPages) {
            if (end < totalPages - 1) {
                rangeWithDots.push('...');
            }
            rangeWithDots.push(totalPages);
        }

        return rangeWithDots;
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages && page !== currentPage) {
            onPageChange(page); // Use 1-based index directly
        }
    };

    const startItem = (currentPage - 1) * pageSize + 1;
    const endItem = Math.min(currentPage * pageSize, totalItems);

    return (
        <Row className="justify-content-md-end justify-content-center align-items-center my-2">
            {showInfo && (
                <Col>
                    <div className="dataTables_info">
                        Showing {startItem} to {endItem} of {totalItems} Results
                    </div>
                </Col>
            )}
            <Col className="col-md-auto">
                <div className="dataTables_paginate paging_simple_numbers">
                    <ul className={className} style={{ listStyle: 'none', display: 'flex', margin: 0, padding: 0 }}>

                        {/* Previous Button */}
                        <li style={{ margin: '0 2px' }}>
                            <button
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                style={{
                                    color: "#0C3451",
                                    border: '1px solid #dee2e6',
                                    borderRadius: '0px',
                                    padding: '8px 12px',
                                    backgroundColor: currentPage === 1 ? '#e9ecef' : '#fff',
                                    minWidth: '40px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                                }}
                                title="Previous"
                            >
                                <i className="mdi mdi-chevron-left"></i>
                            </button>
                        </li>

                        {/* Page Numbers */}
                        {getVisiblePages().map((page, index) => (
                            <li key={index} style={{ margin: '0 2px' }}>
                                {page === '...' ? (
                                    <span style={{
                                        color: "#0C3451",
                                        border: '1px solid #dee2e6',
                                        borderRadius: '0px',
                                        padding: '8px 12px',
                                        backgroundColor: '#fff',
                                        minWidth: '40px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        ...
                                    </span>
                                ) : (
                                    <button
                                        onClick={() => handlePageChange(page)}
                                        style={{
                                            color: page === currentPage ? "white" : "black",
                                            backgroundColor: page === currentPage ? "black" : "#fff",
                                            border: '1px solid #dee2e6',
                                            borderRadius: '0px',
                                            padding: '8px 12px',
                                            minWidth: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontWeight: page === currentPage ? 'bold' : 'normal',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {page}
                                    </button>
                                )}
                            </li>
                        ))}

                        {/* Next Button */}
                        <li style={{ margin: '0 2px' }}>
                            <button
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                style={{
                                    color: "#0C3451",
                                    border: '1px solid #dee2e6',
                                    borderRadius: '0px',
                                    padding: '8px 12px',
                                    backgroundColor: currentPage === totalPages ? '#e9ecef' : '#fff',
                                    minWidth: '40px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                                }}
                                title="Next"
                            >
                                <i className="mdi mdi-chevron-right"></i>
                            </button>
                        </li>

                    </ul>
                </div>
            </Col>
        </Row>
    );
};

export default Pagination;
